module.exports = __webpack_public_path__ + "media/icq.88f9e3aa.mp3";